/**
 * Real-time Variant Fix - Always checks current selection at form submission
 * This script ensures the correct variant is always added regardless of what was previously selected
 */

(function() {
  'use strict';
  
  console.log('⚡ Real-time Variant Fix: Starting...');
  
  // Function to get the currently selected variant ID from the active form
  function getCurrentlySelectedVariantId() {
    const activeForm = document.querySelector('form[action*="/cart/add"]');
    if (!activeForm) {
      console.log('⚡ Real-time Fix: No active cart form found');
      return null;
    }
    
    const variantPicker = activeForm.closest('product-form-component')?.querySelector('variant-picker');
    if (!variantPicker) {
      console.log('⚡ Real-time Fix: No variant picker found in active form');
      return null;
    }
    
    // Check for selected radio button
    const selectedRadio = variantPicker.querySelector('input[type="radio"]:checked');
    if (selectedRadio && selectedRadio.dataset.variantId) {
      console.log('⚡ Real-time Fix: Found selected radio button with variant ID:', selectedRadio.dataset.variantId);
      return selectedRadio.dataset.variantId;
    }
    
    // Check for selected option in select
    const selectedOption = variantPicker.querySelector('select option:checked');
    if (selectedOption && selectedOption.dataset.variantId) {
      console.log('⚡ Real-time Fix: Found selected option with variant ID:', selectedOption.dataset.variantId);
      return selectedOption.dataset.variantId;
    }
    
    // Check for any checked input with variant ID
    const checkedInput = variantPicker.querySelector('input:checked');
    if (checkedInput && checkedInput.dataset.variantId) {
      console.log('⚡ Real-time Fix: Found checked input with variant ID:', checkedInput.dataset.variantId);
      return checkedInput.dataset.variantId;
    }
    
    console.log('⚡ Real-time Fix: No selected variant found in picker');
    return null;
  }
  
  // Function to force update the variant ID in a form
  function forceUpdateVariantId(form, correctVariantId) {
    const variantIdInput = form.querySelector('input[name="id"]');
    if (variantIdInput) {
      const oldValue = variantIdInput.value;
      variantIdInput.value = correctVariantId;
      console.log('⚡ Real-time Fix: Updated variant ID input from', oldValue, 'to', correctVariantId);
      
      // Dispatch events to ensure all listeners are notified
      variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      variantIdInput.dispatchEvent(new Event('input', { bubbles: true }));
    } else {
      console.error('⚡ Real-time Fix: No variant ID input found in form');
    }
  }
  
  // Override form submission to always check current selection
  document.addEventListener('submit', function(event) {
    const form = event.target;
    if (form && form.action && form.action.includes('/cart/add')) {
      console.log('⚡ Real-time Fix: Form submission detected');
      
      // Get the currently selected variant ID
      const currentVariantId = getCurrentlySelectedVariantId();
      
      if (currentVariantId) {
        console.log('⚡ Real-time Fix: Current selected variant ID:', currentVariantId);
        
        // Force update the form with the correct variant ID
        forceUpdateVariantId(form, currentVariantId);
        
        // Also update the form data directly
        const formData = new FormData(form);
        const currentFormVariantId = formData.get('id');
        
        if (currentFormVariantId !== currentVariantId) {
          console.log('⚡ Real-time Fix: Updating form data from', currentFormVariantId, 'to', currentVariantId);
          formData.set('id', currentVariantId);
        }
      } else {
        console.warn('⚡ Real-time Fix: No variant selected, using default');
      }
    }
  }, true); // Use capture phase to run before other handlers
  
  // Override fetch to always check current selection
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    if (url && url.includes('/cart/add')) {
      console.log('⚡ Real-time Fix: Intercepting fetch to /cart/add');
      
      // Get the currently selected variant ID
      const currentVariantId = getCurrentlySelectedVariantId();
      
      if (currentVariantId && options && options.body instanceof FormData) {
        const formData = options.body;
        const currentFormVariantId = formData.get('id');
        
        console.log('⚡ Real-time Fix: Fetch - Current form variant ID:', currentFormVariantId);
        console.log('⚡ Real-time Fix: Fetch - Current selected variant ID:', currentVariantId);
        
        if (currentFormVariantId !== currentVariantId) {
          console.log('⚡ Real-time Fix: Fetch - FORCING variant ID from', currentFormVariantId, 'to', currentVariantId);
          formData.set('id', currentVariantId);
          formData.set('variant_id', currentVariantId);
          formData.set('variantId', currentVariantId);
        }
      }
    }
    
    return originalFetch.call(this, url, options);
  };
  
  // Override XMLHttpRequest to always check current selection
  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;
  
  XMLHttpRequest.prototype.open = function(method, url, ...args) {
    this._url = url;
    return originalXHROpen.call(this, method, url, ...args);
  };
  
  XMLHttpRequest.prototype.send = function(data) {
    if (this._url && this._url.includes('/cart/add')) {
      console.log('⚡ Real-time Fix: Intercepting XHR to /cart/add');
      
      // Get the currently selected variant ID
      const currentVariantId = getCurrentlySelectedVariantId();
      
      if (currentVariantId && data instanceof FormData) {
        const currentFormVariantId = data.get('id');
        
        console.log('⚡ Real-time Fix: XHR - Current form variant ID:', currentFormVariantId);
        console.log('⚡ Real-time Fix: XHR - Current selected variant ID:', currentVariantId);
        
        if (currentFormVariantId !== currentVariantId) {
          console.log('⚡ Real-time Fix: XHR - FORCING variant ID from', currentFormVariantId, 'to', currentVariantId);
          data.set('id', currentVariantId);
          data.set('variant_id', currentVariantId);
          data.set('variantId', currentVariantId);
        }
      }
    }
    
    return originalXHRSend.call(this, data);
  };
  
  // Override FormData.set to catch any variant ID changes
  const originalFormDataSet = FormData.prototype.set;
  FormData.prototype.set = function(name, value) {
    if (name === 'id') {
      const currentVariantId = getCurrentlySelectedVariantId();
      if (currentVariantId && value !== currentVariantId) {
        console.log('⚡ Real-time Fix: FormData.set intercepted - forcing variant ID from', value, 'to', currentVariantId);
        value = currentVariantId;
      }
    }
    return originalFormDataSet.call(this, name, value);
  };
  
  // Also override the add to cart button click to ensure correct variant
  document.addEventListener('click', function(event) {
    const button = event.target;
    if (button && (button.type === 'submit' || button.closest('form[action*="/cart/add"]'))) {
      console.log('⚡ Real-time Fix: Add to cart button clicked');
      
      const form = button.closest('form[action*="/cart/add"]');
      if (form) {
        const currentVariantId = getCurrentlySelectedVariantId();
        if (currentVariantId) {
          console.log('⚡ Real-time Fix: Button click - ensuring correct variant ID:', currentVariantId);
          forceUpdateVariantId(form, currentVariantId);
        }
      }
    }
  }, true); // Use capture phase
  
  console.log('⚡ Real-time Variant Fix: Initialized');
  
})();
